import { jsx } from 'panel';
export function template() {
  return jsx("div", {
    sel: '.mp-list-item-container',
    class: {
      'mp-list-item-active': this.attr("active"),
      'mp-list-item-static': this.attr("static"),
      'mp-list-item-disabled': this.attr("disabled")
    }
  }, jsx("slot", null));
}